var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['default-image', { 'low-scaled': _vm.lowScale }],style:(`height: ${typeof _vm.height == 'number' ? _vm.height + 'px' : _vm.height}`)},[_c('img',{attrs:{"src":_setup.defaultPic}})])
}
var staticRenderFns = []

export { render, staticRenderFns }